angular.module("vgresiduos").component("removeReportAlert", {
	controller: "removeReportAlertCtrl",
	templateUrl: "views/components/removeReportAlert/removeReportAlert_template.html",
	bindings: {
		name: "@",
		type: "@?"
	}
});
